import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SimpleTable from '../../components/SimpleTable';
import CarAssociationDialog from '../../components/CarAssociationDialog';

export default function CarList(props) {
  const { cust_id, carData, customerData, onDataRefresh } = props;
  const [tableData, setData] = React.useState(carData || {});
  const [filterText, setFilterText] = React.useState('');
  const [associationDialogOpen, setAssociationDialogOpen] = React.useState(false);

  // Update local state when props change
  React.useEffect(() => {
    setData(carData || {});
  }, [carData]);

  const handleFilterChange = (event) => {
    setFilterText(event.target.value);
  };

  const filteredRows = tableData.rows ? tableData.rows.filter(row => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return ['car', 'status', 'location', 'stock', 'type', 'number'].some(key =>
      row[key] != null && row[key].toString().toLowerCase().includes(search)
    );
  }) : [];

  const handleAssociationSuccess = () => {
    // Refresh the car data by calling the parent's refresh function
    if (onDataRefresh) {
      onDataRefresh();
    }
  };

  return (
    <Box sx={{ position: 'relative', minHeight: '400px' }}>
      <Grid container spacing={3}>
        {/* Filter */}
        <Grid item xs={12}>
          <TextField 
            label="Filter by car, status, location, stock, type..."
            variant="outlined" 
            fullWidth 
            margin="normal"
            value={filterText}
            onChange={handleFilterChange}
          />
        </Grid>

        {/* Table */}
        <Grid item xs={12}>
          <div>Number of records: {filteredRows.length}</div>
          <SimpleTable key={filterText} {...tableData} rows={filteredRows} linkLocation="_self"/>
        </Grid>
      </Grid>

      {/* Floating Action Button */}
      <Fab
        color="primary"
        aria-label="associate with car"
        onClick={() => setAssociationDialogOpen(true)}
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1000
        }}
      >
        <AddIcon />
      </Fab>

      {/* Association Dialog */}
      <CarAssociationDialog
        open={associationDialogOpen}
        onClose={() => setAssociationDialogOpen(false)}
        customerId={cust_id}
        customerData={customerData}
        onSuccess={handleAssociationSuccess}
      />
    </Box>
  );
}